// {{ $t('立即添加') }}
// $t('立即添加')
// this.$t('立即添加')

export default {
  邮件号: 'Mail',
  通讯录云数据库: 'Contacts Cloud Database',
  云展访问人数: 'Cloud Exhibition Visitors',
  云展访问量: 'Cloud Exhibition Visits',
  邮件阅读量: 'Email Readership',
  访问量: 'Visits',
  数据持续收集中: 'Data collection is ongoing',
  邮件ID: 'Mail ID',
  发送类型: 'Sending Type',
  邀约信息: 'Invitation Information',
  邀约详情: 'Invitation details',
  新建: 'Add',
  请上传附件: 'Please upload attachment',
  上传附件: 'Upload attachment',
  分条: 'Split',
  内容: 'Content',
  国际区号: 'Country Code',
  链接材料文件大小限制提示: 'Maximum file/picture size: 10MB!',
  最多可上传3个文件: '3 files at most',
  链接描述最多输入120个字符: 'Link description is limited to 120 characters',
  链接描述不能为空: 'Link description cannot be empty',
  链接最多输入500个字符: 'Each link is limited to 200 characters',
  链接不能为空: 'Link cannot be empty',
  链接名称最多输入10个字符: 'Link name is limited to 10 characters',
  链接名称不能为空: 'Link name cannot be empty',
  链接提示5: 'You can upload 3 files at most, picture/file formats are accepted. Maximum file size: 10M',
  链接提示4: 'If you want to use RCS, an ICP Filing Certificate for this link is required',
  链接提示3: 'Please describe the link in detail',
  链接提示2: 'Please copy the complete link and paste it into the input box below',
  链接提示1: 'Mainly used for link identify management',
  创建链接: 'Create a link',
  邀约必须为22: 'SMS signature is limited to 2-8 characters!',
  邀约不能为空: 'SMS signature cannot be empty',
  下载: 'Download',
  资质证明材料: 'Qualification Certificate Materials',
  创建多媒体邀约签名: 'Create a RCS signature',
  创建普通邀约: 'Create a SMS signature',
  最少输入10000点提示1: 'Minimum: 10,000 points; Maximum: 1 million points！',
  输入值不可包含小数点: 'The input content cannot contain  decimal point',
  自定义点数: 'Custom points',
  点数: 'points',
  确认充值: 'Confirm',
  平均: 'Average',
  邀约购买: 'SMS Fee',
  点: 'Point',
  立即发送: 'Send Now',
  邀约首页: 'SMS Home',
  链接管理: 'Link Management',
  邀约首页提示语1:
    '1、The first 70 characters (including signature and the unsubscription link) are counted and billed as one text message.For every additional 67 characters, fee for an extra text message will be charged.Every punctuation, number, letter, or Chinese character, and etc., will be counted as one character.',
  邀约首页提示语2:
    '2、RCS—— Maximum Template Size: 1.9M; Maximum Video Size: 50M(automatically compressed); Preferable Duration: Within 33 Seconds; Preferable Landscape Video Resolution: 1920*1080px; Preferable Portrait Video Resolution: 1080*1920px; Preferable Image Resolution: 50kb-1.8M; Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px.;',
  邀约首页提示语3:
    '3、SMS costs 1 point/item, RCS costs 4 points/item. When sending SMS, system will automatically deduct the corresponding points, if it fails, it will be returned；',
  邀约首页提示语4: '4、SMS, RCS  accepts China numbers only (excluding Hong Kong, Taiwan, and Macau)；',
  邀约首页提示语5: '5、SMS signature cannot be modified after approved ！',
  冻结中: 'Freezing',
  短信余量: 'SMS Remaining',
  审核中: 'Under Review',
  审核拒绝: 'Rejected（points）',
  普通邀约签名: 'SMS Signature',
  多媒体邀约签名: 'RCS Signature',
  创建签名: 'Create a signature',
  // 立即充值即表示同意: 'Recharge Now',
  // 云展动力精准邀约服务使用协议:
  //   'Could Exhibition SMS Marketing Service  Agreement',
  什么叫普通邀约: 'What is SMS? What is RCS？',
  什么叫普通邀约提示: 'SMS: Only support text content. RCS: Support text, picture and video content.',
  发普通邀约: 'Send SMS',
  // 发多媒体邀约: 'Send RCS',

  // 创建签名
  创建普通邀约提示语1:
    'The SMS signature must be the brand name or the abbreviation of the company with intellectual property rights between 2-8 characters (No special characters). Each letters, Chinese characters and numbers are all calculated as one character；',
  创建普通邀约提示语2: '2、The signature cannot be revoked after submission and cannot be modified after approval！',
  资质证明提示语1: '1、Please download the template, fill it out and then upload it, doc/docx formats are accepted.；',
  资质证明提示语2:
    '2、You need to upload the authorization letter and the scanned copy of the business license (with the official seal). If the signature is inconsistent with the seal of the enterprise, you need to provide the proof (including the trademark authorization letter, screenshot of the product introduction on the official website, etc).',
  // 预览短信: 'SMS Preview',
  短信正文内容: 'SMS text content, reply T to unsubscribe',

  // 发送平台短信
  发送短信提示语1: '1、SMS costs 1 point/item, RCS costs 4 points/item；',
  发送短信提示语2: '2、SMS, RCS  accepts China phone numbers only (excluding Hong Kong, Taiwan, and Macau)；',
  发送短信提示语3:
    '3、Use Big-Data Customer Database requires additional payment: SMS costs 3 point/item, RCS costs 6 points/item. For example, if you want to send a SMS containing 40 characters and 10 mobile phone numbers using the Big-Data Customer Database, the total costs: 10*1 points/SMS + 10*3 points/phone number = 40 points',
  数据库标签: 'Database tag',

  请输入11位国内有效手机号: 'Please enter an 11-digit phone number,  press Enter key to confirm',
  发送普通邀约注意信息: 'Notice: Each SMS is limited to 100,000 phone numbers',
  发送多媒体邀约注意信息: 'Each RCS is limited to 50,000 phone numbers',
  普通标签说明: '1、Ordinary tag: import the phone number and send it by yourself；',
  云数据标签说明普通:
    '2、Cloud Data: Based on Big-data analysis, the system provides potential customers phone numbers, and each phone number is charged with 2 additional points',
  云数据标签说明富信:
    '2、Cloud Data: Based on Big-data analysis, the system provides potential customers phone numbers, and each phone number is charged with 3 additional points',

  云数据: 'Cloud Data',
  '云数据&其他': 'Cloud Data & Other',
  发送主题提示语: '1、Used as a message  remark only',
  发送手机提示语:
    '1、Please enter an 11-digit phone number (accepted China phone numbers only),  Press Enter key to confirm',
  选择短信模板提示语: '1、Please create a template before sending a message',
  清空: 'Delete',
  确定是否清空: 'Are you sure you want to delete?',
  批量导入号码: 'Batch import phone number',
  批量导入提示语1: '1、xls/xlsx formats are accepted；',
  批量导入提示语2: '2、Each phone number will occupy one row, accepted China 11-digit phone number only!；',
  通讯录导入手机号: 'Import phone numbers from my address list',
  通讯录导入群组: 'Import the contact groups from my address list',

  请选择数据库标签: 'Please choose a Database tag!',
  请输入主题内容: 'Please enter the subject!',
  最多填写10个字符: 'Character limit: 10 characters',
  发送手机至少输入1个手机号: 'Please enter at least one  cellphone!',
  请选择发送的模板: 'Please choose template',

  // 选择发送手机号
  选择发送手机号: 'Please choose phone number',
  客户姓名: 'Customer Name',
  发送的行业分类: 'The type of industry',
  添加客户库: 'Add to address book',

  // 选择模板
  选择普通邀约模板: 'Choose SMS template',
  选择多媒体邀约模板: 'Choose RCS template',
  点击预览: 'Preview',
  // 链接管理
  链接管理提示语1:
    '1、If you want to use the link, first you should submit the link to the website, and the short link will be generated after the submission is approved；',
  链接管理提示语2: '2、If the link is not reviewed, it cannot be used in the message template；',
  链接管理提示语3:
    '3、It is prohibited to publish illegal or inappropriate in link involving politics, or containing pornography, violence, vulgarity, and etc. Once discovered, the user will be suspended and will be reported to the police！',
  链接管理提示语4: '4、If you want to use RCS, an ICP Filing Certificate for this link is required',

  链接: 'Link',
  发布记录: 'Post History',
  历史链接: 'Previous Link',
  效果: 'Preview',

  链接ID: 'Link ID',
  链接描述: 'Link Description',
  剩余有效天数: 'Remaining days',
  编辑ID: 'Edit ID',
  编辑类型: 'Type',

  链接名称: 'Link Name',

  累计访问量: 'Total Visits',
  累计访问人数: 'Total Visitors',
  访问明细列表: 'Detail List',
  访问IP: 'IP Address',
  最新访问时间: 'Latest Visit Time',
  访问人次数: 'Total Visits',
  独立访问人数: 'Total Visitors',

  审核拒绝的原因: 'Rejected Reasons',
  链接相关证明材料附件: 'Relevant certification materials attachments of links',
  链接描述提示语: '1、Please describe the link in detail',
  链接提示语: '1、Please copy the complete link and paste it into the input box below',
  链接名称提示语: '1、Mainly used for link identify management',
  链接附件提示语1: '1、If you want to use RCS, an ICP Filing Certificate for this link is required',
  链接附件提示语2: '2、You can upload 3 files at most, picture/file formats are accepted. Maximum file size: 10M',

  // 邀约记录
  普通邀约记录: 'SMS History',
  多媒体邀约记录: 'RCS History',
  查看发送明细: 'Send details',
  发送中短信提示语:
    'The text message is being sent, you can’t check the sending details. When it has sent, you can check the relevant sending result data!',

  记录ID: 'ID Record',
  任务批次: 'Task Process',
  发送成功: 'Send Successfully',
  发送失败: 'Send Failed',
  已发送: 'Sending',
  待发送: 'Ready to send',
  付费手机号: 'Charge Phone Number',
  任务状态: 'Status',

  // Sending Details
  发送明细提示语: 'Notice:  the data will be updated in batches after sending！',
  发送分条数: 'Successfully sent ',
  发送成功分条数: 'Successfully sent ',
  发送失败分条数: 'Failed to send ',

  发送成功手机号: 'Successfully sent phone',
  发送对象: 'Send Object',
  提交信息: 'Submit Information',

  邮件模板id: 'Email Template ID',
  邮件发送主题: 'Email Subject',
  发送数: 'Send Number',

  // 短信模板
  普通模板: 'Ordinary Template',
  多媒体模板: 'RCS Template',
  创建普通模板: 'Create an Ordinary Template',
  创建多媒体模板: 'Create an RCS Template',
  模板首页提示1: '1、SMS cannot contain special characters or emoji, such as 【】、■、※、✔, etc.',
  模板首页提示2:
    '2、The first 70 characters (including signature and the unsubscription link) are counted and billed as one text message.For every additional 67 characters, fee for an extra text message will be charged.Every punctuation, number, letter, or Chinese character, and etc., will be counted as one character.',
  模板首页提示3:
    '3、RCS—— Maximum Template Size: 1.9M; Maximum Video Size: 50M(automatically compressed); Preferable Duration: Within 33 Seconds; Preferable Landscape Video Resolution: 1920*1080px; Preferable Portrait Video Resolution: 1080*1920px; Preferable Image Resolution: 50kb-1.8M; Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px.',
  普通邀约模板规范: 'Example of SMS',
  多媒体邀约模板规范: 'Example of RCS',
  营销短信法规政策要求: 'Regulations and Policy of SMS Marketing',
  无需审核: 'No review required',
  模板ID: 'Template ID',
  模板名称: 'Template Name',
  更新时间: 'Date of Update',
  失效时间: 'Expiration Date',
  主题: 'Subject Line',
  模板大小: 'Template Size',
  正常可用: 'Available',
  模板已过期: 'Template expired',
  审核不通过: 'Rejected',
  模板已禁用: 'This template has been banned',
  模板不存在: 'This template doesn’t exist',
  运营商状态: 'Operator Status',
  审核备注: 'Notes',
  审核要求: 'Review Requirements',
  邀约: 'SMS Signature',
  创建人所属公司: 'Your Company',
  创建人: 'Your Name',
  创建时间: 'Created on',
  中国移动: 'China Mobile',
  中国联通: 'China Unicom',
  中国电信: 'China Telecom',
  港澳台及国外: 'Hong Kong, Macao, Taiwan and Overseas',
  未知: 'Unknown',
  普通模板添加模板名称说明: 'This template will only serve as an example, not to be sent as an actual message.',

  模板名称不能为空: 'Template name cannot be empty！',
  模板名称最多输入10个字符: 'Template name is limited to 10 characters!',
  模板正文内容: 'Text Message Content',
  添加普通邀约模板正文说明1:
    '1、The first 70 characters (including signature and the unsubscription link) are counted and billed as one text message.For every additional 67 characters, fee for an extra text message will be charged.Every punctuation, number, letter, or Chinese character, and etc., will be counted as one character. Character limit: 1000 characters (including signature).',
  添加普通邀约模板正文说明2:
    '2、Before inserting a link into your template, please submit the link for review first. A short link will be generated once your link is approved.',
  去报备链接: 'Submit Link for Review',
  模板内容不能为空: 'Message content cannot be empty',
  模板内容最多输入1000个字符: 'Character limit: 1000 characters',
  插入短链接: 'Insert Link',
  文本框删除短链需先选中链接文本: 'Text box to delete short links need to select the link text first',
  请在左侧输入短信内容: 'Please enter the message on the left',
  短信模板添加成功: 'Template added successfully.',
  短信模板添加多媒体邀约模板主题提示1:
    '1、The subject line will be displayed when sending the SMS. Please avoid using special characters in the subject line',
  短信模板添加多媒体邀约模板主题提示2: '2、Subject line is limited to 1-15 characters and cannot be empty',
  主题不能为空: 'Subject line cannot be empty',
  模板主题中请勿输入: 'Please do not enter ',
  短信模板添加多媒体邀约模板正文提示1:
    '1、When inserting links, please make sure to put a space before and after the link；',
  短信模板添加多媒体邀约模板正文提示2:
    '2、The template must contain text, and cannot contains only texts, images, audios, or videos；',
  短信模板添加多媒体邀约模板正文提示3: '3、Maximum template size: 1.9M；',
  短信模板添加多媒体邀约模板正文提示4:
    '4、The message content cannot contain special characters, such as 【】、[ ], and etc；',
  短信模板添加多媒体邀约模板正文提示5:
    '5、Button to unsubscribe will be added automatically to the end of the message；',
  短信模板添加多媒体邀约模板正文提示6:
    '6、Before inserting a link into your template, please submit the link for review first. A short link will be generated once your link is approved；',
  文本: 'Text',
  模板内容最多输入500个字符: 'Character limit: 500 characters',
  点击添加: 'Add',
  短信模板添加多媒体邀约模板图片提示1:
    '1、PNG/JPG/JPEG/GIF formats are accepted. Preferable Landscape Image Resolution: 1920*1080px; Preferable Portrait Image Resolution: 962*1300px; Maximum Height: 3000px；',
  短信模板添加多媒体邀约模板图片提示2:
    '2、To ensure the RCS file size won’t exceed 1.9M, it is recommended to keep your pictures below 1.8M',
  短信模板添加多媒体邀约模板视频提示1:
    'Maximum size: 1.8M. MP4/3GP formats are accepted. Preferably MP4 format, within 33 seconds。',
  短信模板添加多媒体邀约模板审核要求提示1:
    '1、You can write down your review requirements here. For example, the template only needs review for China Mobile, not for China Unicom and China Telecom; or you want to have the review result in 2 hours',
  选填: 'Optional',
  短信模板添加多媒体邀约模板备注提示1:
    '1、It can be used to note down the purpose of the current template, such as for sending birthday greetings to customers.',
  目前模板大小: 'Current Template Size',
  最大: 'Maximum',
  模板正文必须包含文字: 'Template content must contain text!',
  模板正文不能为纯文本: 'Template content cannot contain text only!',
  模板正文大小超过: 'The message content has exceeded',
  多媒体模板添加成功: 'Template Added Successfully。',
  视频传压缩提示: 'The video is being uploaded and compressed, please do not close this page.',
  // 邮件
  // 允许常见图片类型、压缩文件、OFFICE文档上传
  邮件附件提示_1: 'Common picture formats, compressed files, and OFFICE documents are accepted for upload',
  // 支持多文件自动上传，单个附件最大允许15M，单个图片最大允许1M。附件大小和计费有关，请谨慎控制邮件大小！
  邮件附件提示_2:
    'Supports multiple file uploads, with a maximum of 15M per attachment and 1M per image. Please control the email size carefully as it affects billing.',
  最多可上传5个文件: '5 files at most, please delete some files before adding new ones',
  // 该附件大小超出限制（图片最大 1MB / 其他文件最大 15MB），请更换
  邮件附件超出大小: 'The attachment size exceeds the limit (1MB for images / 15MB for other files), please replace it.',
  邮件附件总大小超出限制:
    'The total size of all attachments exceeds the 30MB limit, please delete some files before adding new ones',
  返回上一级页面: 'Return to previous page',
  模板已提交: 'The template has been submitted, please wait for the review',
  请您耐心等待: 'Estimated review time: 1-3 business days, please be patient',
  新建一个电子邮件模板: 'Create an email template',
  创建客户库并添加客户: 'Create a customer database and add customers',
  创建任务: 'Create a task',
  快速创建群发任务: 'Quickly create a mass task',
  查看统计: 'View statistics',
  查看发送任务的整体效果: 'View the overall effect of the sending task',
  邮件模板名称: 'Email template name',
  开始结束时间: 'Start/End Time',
  邮件发送统计: 'Email Sending Statistics',
  草稿: 'Draft',
  大小: 'Size',
  修改时间: 'Modification Time',
  测试时间: 'Test Time',
  收件邮箱: 'Recipient Email',
  模板已禁用: 'Template Disabled',
  模板不存在: 'Template Not Found',
  模板已过期: 'Template Expired',
  检测中: 'Checking',
  检测耗时: 'The checking usually takes 1-5 seconds, depending on the complexity and size of the template',
  该模板邮件发送可能存在被拦截的风险: 'This template may be intercepted',
  平台允许发送:
    'This template may be directly intercepted by major service providers, it is recommended to edit and resend (platform allows sending)',
  禁止发送:
    'This template may be directly intercepted by major service providers, it is recommended to edit and resend (sending prohibited)',
  可以发送: 'This template has passed the check and can be sent',
  较高风险:
    'High risk detected in the current template, it is recommended to optimize the email subject, content, or materials before sending',
  一定风险:
    'Template check completed, there is some risk, it is recommended to adjust keywords, images, or structure before sending test',
  检测合格:
    'This template has passed the check and can be sent for testing or view the test records of the last 3 days',
  设置共享成功: 'Sharing set successfully',
  取消共享成功: 'Sharing canceled successfully',
  请输入测试接收邮箱: 'Please enter the test recipient email',
  发送测试成功: 'Test sent successfully',
  删除该模板: 'This action cannot be undone. Are you sure you want to delete this template?',
  打开率: 'Open Rate',
  点击率: 'Click Rate',
  成功率: 'Success Rate',
  停止任务: 'Stop Task',
  暂停发送: 'Pause Sending',
  取消计划: 'Cancel Plan',
  失败地址重发: 'Resend Failed Address',
  修改任务: 'Modify Task',
  收件人: 'Recipient',
  取消计划成功: 'Cancel Plan Success',
  停止任务成功: 'Stop Task Success',
  暂停发送成功: 'Pause Sending Success',
  开始发送: 'Start Sending',
  重发成功: 'Resend Success',
  新建普通模板: 'Create Normal Template',
  新建可视化模板: 'Create Visual Template',
  仅作为邮件的展示: 'For display only, not for content sending',
  邮件模板编辑: 'Email Template Editing',
  关联: 'Association',
  退订: 'Add Unsubscribe/Complaint',
  参考模板: 'Reference Template',
  使用: 'Use',
  拖拽搭建邮件正文: 'Drag and drop to build email content',
  支持区块拖拽:
    'Supports block dragging, HTML import, button and image replacement, the editing result will be directly saved as the template content',
  进入可视化编辑: 'Enter Visual Editing',
  修改邮件模板: 'Modify Email Template',
  创建邮件模板: 'Create Email Template',
  最多可上传5个文件: '5 files at most, please delete some files before adding new ones',
  邮件附件超出大小: 'The attachment size exceeds the limit (1MB for images / 15MB for other files), please replace it.',
  邮件附件总大小超出限制:
    'The total size of all attachments exceeds the 30MB limit, please delete some files before adding new ones',
  该变量已添加: 'The variable has been added',
  选择邮件模板: 'Select Email Template',
  邮件主题发件人: 'Email Subject & Sender',
  发送给: 'Send To',
  链接追踪发送设置: 'Link Tracking & Sending Settings',
  创建邮件任务: 'Create Email Task',
  编辑邮件任务: 'Edit Email Task',
  查看模板: 'View Template',
  该模板约扣: 'This template will deduct',
  个点数: 'points',
  预发送效果检测: 'Pre-send Effect Check:',
  主题: 'Subject',
  发件人: 'Sender',
  回复邮箱: 'Reply Email',
  您的发送邮件对象是谁: 'Who is your email recipient?',
  统计收件人总数: 'Total recipients: ',
  邮箱: 'Email',
  收件人: 'Recipient',
  是否去重: 'Remove Duplicates',
  发送时间: 'Sending Time',
  每小时发送量: 'Hourly Sending Limit',
  跟踪邮件打开与链接点击情况: 'Track Email Opens and Link Clicks',
  请填写主题: 'Please enter the subject',
  主题不能超过250个字符: 'The subject cannot exceed 250 characters',
  发件人名称: 'Sender Name',
  请填写发件人名称: 'Please enter the sender name',
  发件人名称不能超过50个字符: 'The sender name cannot exceed 50 characters',
  回复人邮箱: 'Reply Email',
  请填写回复人邮箱: 'Please enter the reply email',
  请搜索联系人群组: 'Please search contact groups',
  发送数量: 'Sending Quantity',
  全部地址: 'All Addresses',
  部分地址: 'Partial Addresses',
  最小发送量: 'Minimum Sending Quantity',
  请选择客户群组: 'Please select a customer group',
  请选择模板: 'Please select a template',
  请填写每小时发送量: 'Please enter the hourly sending limit',
  最大发送量: 'Maximum Sending Quantity',
  最小发送量: 'Minimum Sending Quantity',
  每小时发送量: 'Hourly Sending Limit',
  每小时发送量必须为正整数: 'The hourly sending limit must be a positive integer',
  最大发送量不能超过已选邮箱数: 'The maximum sending quantity cannot exceed the number of selected emails',
  最大发送量不能小于最小发送量: 'The maximum sending quantity cannot be less than the minimum sending quantity',
  最大发送量需大于0: 'The maximum sending quantity must be greater than 0',
  最小发送量需大于0: 'The minimum sending quantity must be greater than 0',
  当前仅支持从客户群组选择收件人: 'Currently, only selecting recipients from customer groups is supported',
  请输入正确的邮箱格式: 'Please enter a valid email format',
  模板内容不能为空: 'The template content cannot be empty',
  请填写回复人邮箱: 'Please enter the reply email',
  请选择模板变量: 'Please select template variables',
  选择联系人: 'Select Contacts',
  预计消耗邀约总点数: 'Estimated Total Points Consumption',
  跟踪邮件打开与链接点击情况: 'Track Email Opens and Link Clicks',
  发送时间: 'Sending Time',
  去掉重复的邮箱: 'If checked, duplicate emails will be removed when sending by contact category.',
}
